const $document = $(document);
const $test = $('.test');
const $start = $test.find('.test__start');
const $step = $test.find('.test__step');
const $result = $test.find('.test__result');
const $answer = $test.find('.test__answer');
const $resultTitle = $result.find('.test__name');
const $resultSvg = $result.find('.test__svg');
const $resultText = $result.find('.test__description');
const $content = $test.find('.test__content');

const $startButton = $test.find('.js-test-start');
const $answerButton = $test.find('.js-test-answer');
const $nextButton = $test.find('.js-test-next');
const $reloadButton = $test.find('.js-test-reload');

const $headerTest = $('.header__test');

let rate = 0;

function getResultIndex() {
	let index = 1;

	if (rate >= 13 && rate <= 16) {
		index = 0;
	} else if (rate >= 17 && rate <= 20) {
		index = 1;
	} else if (rate >= 9 && rate <= 12) {
		index = 2;
	} else if (rate >= 5 && rate <= 8) {
		index = 3;
	}

	return index;
}

function setUrlParam(resetParams) {
	let url = '';
	let resultParamExists = location.search.indexOf('result=') !== -1;

	if (resetParams && resultParamExists) {
		url = location.origin + location.pathname;

		history.replaceState(null, null, url);
	} else if (!resetParams) {
		url = `${location.origin}${location.pathname}?result=${getResultIndex()}`;

		history.replaceState(null, null, url);
	}
}

function reset() {
	// correctAnswersCount = 0;
	rate = 0;

	$start.removeClass('is-hidden');
	$step.addClass('is-hidden').removeClass('is-done');
	$result.addClass('is-hidden');
	// $share.removeClass('is-hidden');
	// $banner.addClass('is-hidden');
	$answer.removeClass('is-selected is-correct is-wrong');
	$resultTitle.addClass('is-hidden');
	$resultSvg.addClass('is-hidden');
	$resultText.addClass('is-hidden');
	$headerTest.addClass('is-hidden');

	$('.test').removeClass([
		'test__is-finish',
		'test__melancholic',
		'test__phlegmatic',
		'test__sanguine',
		'test__choleric',
	]);

	gsap.killTweensOf([$start, $step, $result/* , $share */]);
	gsap.set([$start, $step, $result/* , $share */], {clearProps: 'all'});

	setUrlParam(true);
}

function reload() {
	$nextButton.removeClass('pointer-events');

	$('.test').removeClass('test__is-start');
	$('.test').removeClass('test__is-finish');

	$('.for-desktop--banner-overlay').css({
		display: 'none',
	});

	$('.for-desktop--final, .test__bg-mobile').css({
		display: 'none',
	});

	$('.test__content').removeClass('test__content--media');

	$('.header__right').removeClass('header__right--span');

	$('.for-desktop--left').css({
		'z-index': '-1',
	});

	$content.css({
		'z-index': '3',
	});

	gsap.timeline({
		onComplete: reset,
	})
		.to($result, 0.3, {
			autoAlpha: 0,
		})
		.call(() => {
			$result.addClass('is-hidden');
			$start.removeClass('is-hidden');

			// $share.removeClass('is-hidden');
			// $banner.addClass('is-hidden');
			$headerTest.addClass('is-hidden');

			gsap.killTweensOf($result);
			gsap.set($result, {clearProps: 'all'});
		})
		.from([$start/* , $share, $banner */], 0.3, {
			autoAlpha: 0,
		});

	$document.trigger('test-reload');
}

function result() {
	const resultIndex = getResultIndex();

	const $lastStep = $step.last();
	const $activeResultTitle = $resultTitle.eq(resultIndex);
	const $activeResultText = $resultText.eq(resultIndex);
	const $activeResultSvg = $resultSvg.eq(resultIndex);

	// $('.test').removeClass('test__is-start');
	$('.test').addClass('test__is-finish');
	let activeClass = 'test__';

	switch ($activeResultTitle.text().trim()) {
		case 'Меланхолик':
			activeClass += 'melancholic';
			break;
		case 'Флегматик':
			activeClass += 'phlegmatic';
			break;
		case 'Сангвиник':
			activeClass += 'sanguine';
			break;
		case 'Холерик':
			activeClass += 'choleric';
			break;

		default:
			break;
	}

	$('.test').addClass(activeClass);

	$activeResultTitle.removeClass('is-hidden');
	$activeResultText.removeClass('is-hidden');
	$activeResultSvg.removeClass('is-hidden');

	// $yourResult.text(correctAnswersCount);
	// $yourResult.text(rate);

	gsap.timeline()
		.to([$lastStep/* , $share */], 0.3, {
			autoAlpha: 0,
		})
		.call(() => {
			$lastStep.addClass('is-hidden');
			$result.removeClass('is-hidden');

			gsap.killTweensOf([$lastStep/* , $share, $banner */]);
			gsap.set([$lastStep/* , $share */], {clearProps: 'all'});
		})
		.from([$result], 0.3, {
			autoAlpha: 0,
		});

	setUrlParam();

	$document.trigger('test-result', [`Как ваш темперамент влияет на&nbsp;инвестиции? | ${$activeResultTitle.text()}`.split('', 100).join(''), rate]);
}

function next(event) {
	const $currentStep = $(event.currentTarget).closest('.test__step');
	const $nextStep = $currentStep.next('.test__step');

	if (!$currentStep.hasClass('is-done')) {
		return;
	}

	$('html, body').animate({
		scrollTop: 0,
	}, 500);

	if (!$nextStep.length) {
		$nextButton.addClass('pointer-events');
		result();

		return;
	}

	const nextStepIndex = $nextStep.data('index');
	const nextQuestion = $nextStep.find('.test__question').text();

	$nextButton.addClass('pointer-events');

	gsap.timeline()
		.to($currentStep, 0.3, {
			autoAlpha: 0,
		})
		.call(() => {
			$currentStep.addClass('is-hidden');
			$nextStep.removeClass('is-hidden');
			$nextButton.removeClass('pointer-events');

			gsap.killTweensOf($currentStep);
			gsap.set($currentStep, {clearProps: 'all'});
		})
		.from([$nextStep, $test], 0.3, {
			autoAlpha: 0,
		});

	$document.trigger('test-question-show', [nextStepIndex + 1, 'Как ваш темперамент влияет на&nbsp;инвестиции?', nextQuestion.split('', 100).join('')]);
}

function answer(event) {
	const $currentAnswer = $(event.currentTarget);
	const $currentStep = $currentAnswer.closest('.test__step');

	if ($currentStep.hasClass('is-done')) {
		return false;
	}

	const stepIndex = $currentStep.data('index');

	const answerRate = Number.parseInt($currentAnswer.data('rate'), 10);
	const answerText = $currentAnswer.find('.test__radio').text();

	// if (answerRate === 4) {
	// } else {
	// 	$document.trigger('test-answer', [stepIndex + 1, `NO - ${answerText.split('', 100).join('')}`]);
	// }

	rate += answerRate;
	$document.trigger('test-answer', [stepIndex + 1, 'Как ваш темперамент влияет на&nbsp;инвестиции?' - answerText.split('', 100).join('')]);

	$currentStep.addClass('is-done');
	$currentAnswer.addClass('is-selected');
	$currentStep.find('.test__subtext').addClass('is-hide');

	return true;
}

function start() {
	const $firstStep = $step.first();

	const stepIndex = $firstStep.data('index');
	const question = $firstStep.find('.test__question').text();

	$nextButton.addClass('button-start');

	$('.test').removeClass([
		'test__is-finish',
		'test__melancholic',
		'test__phlegmatic',
		'test__sanguine',
		'test__choleric',
	]);

	$content.css({
		'z-index': '1',
	});

	gsap.timeline()
		.to([$firstStep], 0.3, {
			autoAlpha: 0,
			clearProps: 'all',
		})
		.call(() => {
			$('.test').addClass('test__is-start');
			$start.addClass('is-hidden');
			$firstStep.removeClass('is-hidden');
			// $banner.addClass('is-hidden');
			$headerTest.removeClass('is-hidden');
			$('.test__content').addClass('test__content--media');

			gsap.killTweensOf([$start]);
			gsap.set([$start], {clearProps: 'all'});
		})
		.from([$test, $firstStep], 0.3, {
			autoAlpha: 0,
			clearProps: 'all',
		});

	$document
		.trigger('test-start')
		.trigger('test-question-show', [stepIndex + 1, 'Как ваш темперамент влияет на&nbsp;инвестиции?', question.split('', 100).join('')]);
}

$startButton.on('click', start);
$answerButton.on('click', answer);
$nextButton.on('click', next);
$reloadButton.on('click', reload);

$('.js-footer-test-button, .test-footer__text').on('click', (e) => {
	e.stopPropagation();

	$(e.currentTarget).closest('.test-footer__hover').toggleClass('is-active');
});

export default {
	reset,
};
